import { useSelector, useDispatch } from "react-redux";
import { baseUrl } from "../../config/axios";
import { Link } from "react-router-dom";
import { currency } from "../../utils";
import { removeProductToCart } from "../../redux/slices/userDataSlice";
import InputQuantityCom from "../Helpers/InputQuantityCom";

export default function Cart({ className, type }) {

  const { cart, totalAmount } = useSelector(state => state.userDataReducer)
  const dispatch = useDispatch()

  const handleRemoveProduct = (item) => {
    dispatch(removeProductToCart(item))
  }

  return (
    <>
      <div
        style={{ boxShadow: " 0px 15px 50px 0px rgba(0, 0, 0, 0.14)" }}
        className={`w-[350px] bg-white border-t-[3px] ${type === 3 ? 'border-qh3-blue' : 'cart-wrappwer'}  ${className || ""
          }`}
      >
        <div className="w-full h-full">
          {cart.length > 0 ? (
            <>
              <div className="product-items h-[310px] overflow-y-scroll">
                <ul>
                  {cart?.map((item, index) => (
                    <li key={index} className="w-full h-full flex">
                      <div className="flex space-x-[6px] w-full justify-center items-center px-4 my-[20px]">
                        <div className="w-[65px] h-full">
                          <img
                            src={item?.variantImage ? baseUrl + item.variantImage.imagePath + item.variantImage.image : baseUrl + item?.images[0]?.imagePath + item?.images[0]?.image}
                            alt=""
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <div className="flex-1 h-full w-[172px] flex flex-col justify-center ">
                          <p className="title mb-2 flex-1 text-[13px] font-600 text-qblack leading-4 line-clamp-2 hover:text-blue-600">
                            {item.name}
                          </p>
                          <p className="mb-0 flex-1 text-[13px] font-600 text-qblack leading-4 line-clamp-2">
                            <span className="text-[10px] mr-1 font-normal">
                              <b>{item.parentVariant.type}: </b>
                              {item.parentVariant.name}
                            </span>
                            <span className="text-[10px] font-normal">
                              <b>{item.childVariant.type}: </b>
                              {item.childVariant.name}
                            </span>
                          </p>

                          <p className="price">
                            {item?.variantPrice != null ? (
                              <span className="offer-price text-qred font-600 text-[15px]">
                                {currency}{item?.variantPrice}
                              </span>
                            ) : item?.flash_sale_price > 0 ? (
                              <span className="offer-price text-qred font-600 text-[15px]">
                                {currency}{item?.flash_sale_price}
                              </span>
                            ) : (
                              <>
                                {item?.discounted_price > 0 &&
                                  <span className="text-sm font-500 text-qgray line-through mt-2">
                                    {currency}{item?.price}
                                  </span>
                                }
                                <span className="offer-price text-qred font-600 text-[15px] ml-2">
                                  {currency}{item?.discounted_price > 0 ? item?.discounted_price : item?.price}
                                </span>
                              </>
                            )}
                          </p>

                          <div className="flex items-center mt-2">
                            <InputQuantityCom data={item} style={{ width: '80px', height: '20px', padding: '0px 10px' }} textStyle={{ fontSize: '12px' }} />
                          </div>
                        </div>
                      </div>
                      <span className="mt-[20px] mr-[15px] inline-flex cursor-pointer" onClick={() => handleRemoveProduct(item)}>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="inline fill-current text-[#FF2121] hover:text-qred"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M3 6h18v2H3V6zm2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8H5zm3 2h2v8H8v-8zm4 0h2v8h-2v-8z" />
                        </svg>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="w-full px-4 mt-[20px] mb-[12px]">
                <div className="h-[1px] bg-[#F0F1F3]"></div>
              </div>
              <div className="product-actions px-4 mb-[30px]">
                <div className="total-equation flex justify-between items-center mb-[28px]">
                  <span className="text-[15px] font-500 text-qblack">Subtotal</span>
                  <span className="text-[15px] font-500 text-qred ">{currency}{parseInt(totalAmount).toFixed(2)}</span>
                </div>
                <div className="product-action-btn">
                  <Link to="/cart">
                    <div className="gray-btn w-full h-[50px] mb-[10px] ">
                      <span>View Cart</span>
                    </div>
                  </Link>
                  <Link to="/checkout">
                    <div className="w-full h-[50px]">
                      <div className={type === 3 ? 'blue-btn' : 'yellow-btn'}>
                        <span className="text-sm">Checkout Now</span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="w-full px-4 mt-[20px]">
                <div className="h-[1px] bg-[#F0F1F3]"></div>
              </div>
              <div className="flex justify-center py-[15px]">
                <p className="text-[13px] font-500 text-qgray">
                  Get Return within <span className="text-qblack">30 days</span>
                </p>
              </div>
            </>
          ) : (
            <div className="product-items h-[310px] overflow-y-scroll" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span className="text-[15px] font-500 text-qblack">Cart is empty</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
